import React from "react"
import Paper from "material-ui/Paper"
import strings from "../../localization/strings"
import DonutChart from "../../components/common/donutChart/DonutChart"
import AccountStore from "../../stores/AccountStore"
import { IPayrollTime, IPayrollExpenses } from "../../models"
import * as permissionHelper from "../../helpers/permissionHelper"
import AuthenticationStore from "../../stores/AuthenticationStore"
interface IProps {
    payrollTimeData: IPayrollTime
    payrollExpensesData: IPayrollExpenses
    viewByJob: boolean
}

const PayrollChartCard: React.SFC<IProps> = (props: IProps) => {
    const showPayrollExpense = AccountStore.getExpensesEnabled() &&
        !AccountStore.getExpenseIsPayrollTime() &&
        permissionHelper.hasPermission(AuthenticationStore.Permissions.Expense.ViewPayrollExpense)

    return (
        <Paper zDepth={1} className="page-paper" style={{ height: 135, marginBottom: 25, marginTop: -5, position: "relative" }}>
            <div style={{ textAlign: "center", display: "flex", justifyContent: "space-evenly" }}>
                {permissionHelper.hasPermission(AuthenticationStore.Permissions.Payroll.ViewPayroll) &&
                    <div style={{ position: "relative" }}>
                        {showPayrollExpense &&
                            <div style={{ position: "absolute", left: 0, right: 0, bottom: -16 }}>{strings.Time_Data}</div>
                        }
                        <PayrollTimeDonutChart
                            payrollTimeData={props.payrollTimeData}
                            viewByJob={props.viewByJob}
                        />
                    </div>
                }
                {showPayrollExpense &&
                    <div style={{ position: "relative" }}>
                        <div style={{ position: "absolute", left: 0, right: 0, bottom: -16 }}>{strings.Expenses_Data}</div>
                        <PayrollExpensesDonutChart
                            payrollExpensesData={props.payrollExpensesData}
                            viewByJob={props.viewByJob}
                        />
                    </div>
                }
            </div>
        </Paper>
    )
}

export default PayrollChartCard

interface IChartProps {
    expenseChart: boolean
    empApprovedPercentage: number
    approvedPercentage: number
    extSupApprovedPercentage: number
    empLockedPercentage: number
    lockedPercentage: number
    closedPercentage: number
    exportedPercentage: number
    viewByJob: boolean
}

const PayrollDonutChart: React.SFC<IChartProps> = (props: IChartProps) => {
    const paddingVal = AccountStore.getExpensesEnabled() ? 7 : 30
    return (
        <div>
            {AccountStore.getEmployeeApproveTimecardEnabled() &&
                <div style={{ display: "inline-block", paddingLeft: paddingVal, paddingRight: paddingVal }}>
                    <DonutChart value={props.empApprovedPercentage} strokeWidth={10} size={90} valuelabel={AccountStore.getExtSupApproveTimecardEnabled() ? strings.Employee.toUpperCase() : strings.EMP_Approved.toUpperCase()} />
                </div>
            }
            < div style={{ display: "inline-block", paddingLeft: paddingVal, paddingRight: paddingVal }}>
                <DonutChart value={props.approvedPercentage} strokeWidth={10} size={90} valuelabel={AccountStore.getExtSupApproveTimecardEnabled() ? strings.Supervisor.toUpperCase() : strings.Approved.toUpperCase()} />
            </div >
            {AccountStore.getExtSupApproveTimecardEnabled() && !props.expenseChart &&
                <div style={{ display: "inline-block", paddingLeft: paddingVal, paddingRight: paddingVal }}>
                    <DonutChart value={props.extSupApprovedPercentage} strokeWidth={10} size={90} valuelabel={strings.External.toUpperCase()} />
                </div>
            }
            {!props.viewByJob && [
                AccountStore.getEnableEmployeeLock() &&
                <div key="emp_lock" style={{ display: "inline-block", paddingLeft: paddingVal, paddingRight: paddingVal }}>
                    <DonutChart value={props.empLockedPercentage} strokeWidth={10} size={90} valuelabel={strings.EMP_Locked.toUpperCase()} />
                </div>,
                <div key="lock" style={{ display: "inline-block", paddingLeft: paddingVal, paddingRight: paddingVal }}>
                    <DonutChart value={props.lockedPercentage} strokeWidth={10} size={90} valuelabel={strings.Locked.toUpperCase()} />
                </div>,
                AccountStore.getAccrualsTimeoffEnabled() &&
                <div key="close" style={{ display: "inline-block", paddingLeft: paddingVal, paddingRight: paddingVal }}>
                    <DonutChart value={props.closedPercentage} strokeWidth={10} size={90} valuelabel={strings.Closed.toUpperCase()} />
                </div>,
                <div key="export" style={{ display: "inline-block", paddingLeft: paddingVal, paddingRight: paddingVal }}>
                    <DonutChart value={props.exportedPercentage} strokeWidth={10} size={90} valuelabel={strings.Exported.toUpperCase()} />
                </div>
            ]}
        </div>
    )
}

interface IPayrollTimeChartProps {
    payrollTimeData: IPayrollTime
    viewByJob: boolean
}

const PayrollTimeDonutChart: React.SFC<IPayrollTimeChartProps> = (props: IPayrollTimeChartProps) => {
    let totalNonEmptyEmployees = 0
    if (props.payrollTimeData) {
        if (props.viewByJob) {
            props.payrollTimeData.PayrollTimeJobs.forEach(i => {
                i.PayrollEmployees.forEach(e => {
                    e.JobCostingSummaryList.length &&
                        totalNonEmptyEmployees++
                })
            })
        }
        else {
            props.payrollTimeData.PayrollTimeHierarchies.forEach(i => {
                i.PayrollEmployees.forEach(e => {
                    e.JobCostingSummaryList.length &&
                        totalNonEmptyEmployees++
                })
            })
        }
    }

    let empApprovedPercentage = 0
    if (AccountStore.getEmployeeApproveTimecardEnabled() && props.payrollTimeData) {
        if (totalNonEmptyEmployees) {
            let totalEmpApprovedNonEmptyEmployees = 0
            if (props.viewByJob) {
                props.payrollTimeData.PayrollTimeJobs.forEach(i => {
                    i.PayrollEmployees.forEach(e => {
                        e.JobCostingSummaryList.length &&
                            e.AllPunchsetsEmpApproved &&
                            totalEmpApprovedNonEmptyEmployees++
                    })
                })
            }
            else {
                props.payrollTimeData.PayrollTimeHierarchies.forEach(i => {
                    i.PayrollEmployees.forEach(e => {
                        e.JobCostingSummaryList.length &&
                            e.AllPunchsetsEmpApproved &&
                            totalEmpApprovedNonEmptyEmployees++
                    })
                })
            }
            empApprovedPercentage = Math.floor((totalEmpApprovedNonEmptyEmployees / totalNonEmptyEmployees) * 100)
        }
    }

    let approvedPercentage = 0
    if (props.payrollTimeData) {
        if (totalNonEmptyEmployees) {
            let totalApprovedNonEmptyEmployees = 0
            if (props.viewByJob) {
                props.payrollTimeData.PayrollTimeJobs.forEach(i => {
                    i.PayrollEmployees.forEach(e => {
                        e.JobCostingSummaryList.length &&
                            e.AllPunchsetsApproved &&
                            totalApprovedNonEmptyEmployees++
                    })
                })
            }
            else {
                props.payrollTimeData.PayrollTimeHierarchies.forEach(i => {
                    i.PayrollEmployees.forEach(e => {
                        e.JobCostingSummaryList.length &&
                            e.AllPunchsetsApproved &&
                            totalApprovedNonEmptyEmployees++
                    })
                })
            }
            approvedPercentage = Math.floor((totalApprovedNonEmptyEmployees / totalNonEmptyEmployees) * 100)
        }
    }

    let extSupApprovedPercentage = 0
    if (AccountStore.getExtSupApproveTimecardEnabled() && props.payrollTimeData) {
        if (totalNonEmptyEmployees) {
            let totalExtSupApprovedNonEmptyEmployees = 0
            if (props.viewByJob) {
                props.payrollTimeData.PayrollTimeJobs.forEach(i => {
                    i.PayrollEmployees.forEach(e => {
                        e.JobCostingSummaryList.length &&
                            e.AllPunchsetsExtSupApproved &&
                            totalExtSupApprovedNonEmptyEmployees++
                    })
                })
            }
            else {
                props.payrollTimeData.PayrollTimeHierarchies.forEach(i => {
                    i.PayrollEmployees.forEach(e => {
                        e.JobCostingSummaryList.length &&
                            e.AllPunchsetsExtSupApproved &&
                            totalExtSupApprovedNonEmptyEmployees++
                    })
                })
            }
            extSupApprovedPercentage = Math.floor((totalExtSupApprovedNonEmptyEmployees / totalNonEmptyEmployees) * 100)
        }
    }

    let empLockedPercentage = 0
    if (!props.viewByJob && AccountStore.getEnableEmployeeLock() && props.payrollTimeData) {
        if (props.payrollTimeData.ProgressSummary.TotalEmpLockedHierarchies) {
            empLockedPercentage = Math.floor((props.payrollTimeData.ProgressSummary.TotalEmpLockedHierarchies / props.payrollTimeData.ProgressSummary.TotalHierarchies) * 100)
        }
    }

    let lockedPercentage = 0
    if (!props.viewByJob && props.payrollTimeData) {
        if (props.payrollTimeData.ProgressSummary.TotalLockedHierarchies) {
            lockedPercentage = Math.floor((props.payrollTimeData.ProgressSummary.TotalLockedHierarchies / props.payrollTimeData.ProgressSummary.TotalHierarchies) * 100)
        }
    }

    let closedPercentage = 0
    if (!props.viewByJob && AccountStore.getAccrualsTimeoffEnabled() && props.payrollTimeData) {
        if (props.payrollTimeData.ProgressSummary.TotalClosedHierarchies) {
            closedPercentage = Math.floor((props.payrollTimeData.ProgressSummary.TotalClosedHierarchies / props.payrollTimeData.ProgressSummary.TotalHierarchies) * 100)
        }
    }

    let exportedPercentage = 0
    if (!props.viewByJob && props.payrollTimeData) {
        if (totalNonEmptyEmployees) {
            let totalExportedNonEmptyEmployees = 0
            props.payrollTimeData.PayrollTimeHierarchies.forEach(i => {
                i.PayrollEmployees.forEach(e => {
                    e.Exported &&
                        totalExportedNonEmptyEmployees++
                })
            })
            exportedPercentage = Math.floor((totalExportedNonEmptyEmployees / totalNonEmptyEmployees) * 100)
        }
    }

    return (
        <PayrollDonutChart
            expenseChart={false}
            empApprovedPercentage={empApprovedPercentage}
            approvedPercentage={approvedPercentage}
            extSupApprovedPercentage={extSupApprovedPercentage}
            empLockedPercentage={empLockedPercentage}
            lockedPercentage={lockedPercentage}
            closedPercentage={closedPercentage}
            exportedPercentage={exportedPercentage}
            viewByJob={props.viewByJob}
        />
    )
}

interface IPayrollExpensesChartProps {
    payrollExpensesData: IPayrollExpenses
    viewByJob: boolean
}

const PayrollExpensesDonutChart: React.SFC<IPayrollExpensesChartProps> = (props: IPayrollExpensesChartProps) => {
    const totalEmployees = props.payrollExpensesData ?
        props.payrollExpensesData.PayrollExpensesHierarchies.reduce((total, i) => total + i.TotalEmployees, 0) :
        0
    const totalHierarchies = props.payrollExpensesData ?
        props.payrollExpensesData.PayrollExpensesHierarchies.length :
        0

    let empApprovedPercentage = 0
    if (AccountStore.getEmployeeApproveTimecardEnabled() && props.payrollExpensesData) {
        const totalEmpApprovedEmployees = props.payrollExpensesData.PayrollExpensesHierarchies.reduce((total, i) => total + i.TotalEmpApprovedEmployees, 0)
        if (totalEmployees) {
            empApprovedPercentage = Math.floor((totalEmpApprovedEmployees / totalEmployees) * 100)
        }
    }

    let approvedPercentage = 0
    if (props.payrollExpensesData) {
        const totalApprovedEmployees = props.payrollExpensesData.PayrollExpensesHierarchies.reduce((total, i) => total + i.TotalApprovedEmployees, 0)
        if (totalEmployees) {
            approvedPercentage = Math.floor((totalApprovedEmployees / totalEmployees) * 100)
        }
    }

    let empLockedPercentage = 0
    if (AccountStore.getEnableEmployeeLock() && props.payrollExpensesData) {
        if (totalHierarchies) {
            const totalEmpLockedHierarchies = props.payrollExpensesData.PayrollExpensesHierarchies.filter(i => i.EmpLockedData && i.EmpLockedData.IsLocked).length
            empLockedPercentage = Math.floor((totalEmpLockedHierarchies / totalHierarchies) * 100)
        }
    }

    let lockedPercentage = 0
    if (props.payrollExpensesData) {
        if (totalHierarchies) {
            const totalLockedHierarchies = props.payrollExpensesData.PayrollExpensesHierarchies.filter(i => i.LockedData.IsLocked).length
            lockedPercentage = Math.floor((totalLockedHierarchies / totalHierarchies) * 100)
        }
    }

    let closedPercentage = 0
    if (AccountStore.getAccrualsTimeoffEnabled() && props.payrollExpensesData) {
        if (totalHierarchies) {
            const totalClosedHierarchies = props.payrollExpensesData.PayrollExpensesHierarchies.filter(i => i.ClosedData.IsClosed).length
            closedPercentage = Math.floor((totalClosedHierarchies / totalHierarchies) * 100)
        }
    }

    let exportedPercentage = 0
    if (props.payrollExpensesData) {
        if (totalEmployees) {
            const totalExportedEmployees = props.payrollExpensesData.PayrollExpensesHierarchies.reduce((total, i) => total + i.TotalExportedEmployees, 0)
            exportedPercentage = Math.floor((totalExportedEmployees / totalEmployees) * 100)
            if(exportedPercentage > 100){
                exportedPercentage = 100
            }
        }
    }

    return (
        <PayrollDonutChart
            expenseChart
            empApprovedPercentage={empApprovedPercentage}
            approvedPercentage={approvedPercentage}
            extSupApprovedPercentage={0}
            empLockedPercentage={empLockedPercentage}
            lockedPercentage={lockedPercentage}
            closedPercentage={closedPercentage}
            exportedPercentage={exportedPercentage}
            viewByJob={props.viewByJob}
        />
    )
}